import styled, { keyframes } from 'styled-components';

export const redDotScaleFade = keyframes`
  0% {
    opacity: 0.5;
    transform: scale(1);
  }
  50% {
    opacity: 0;
    transform: scale(2.4);
  }

  100% {
    opacity: 0;
    transform: scale(2.4);
  }
`;

export const ScIndicator = styled.div`
  width: 10px;
  height: 10px;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  & > .red-dot,
  & > .pulse {
    position: absolute;
    height: 10px;
    width: 10px;
    border-radius: 18px;
    background-color: ${({ theme }) => theme.orangeColor};
  }

  & > .pulse {
    animation: ${redDotScaleFade} 2s infinite;
    &.two {
      animation-delay: 0.25s;
    }
  }
`;
